// Traducciones de las paginas publicas (Landing, Login, Registro, Recuperacion, Restablecimiento).
// Se fusiona en el diccionario principal desde i18n.js. Marca "Lura"/"Lura Finance" no se traduce.
export const PUB = {
  es: {
    "pub.landing.navPrivacy": "Privacidad",
    "pub.landing.navLogin": "Iniciar sesión",
    "pub.landing.navStart": "Empezar gratis",
    "pub.landing.heroBadge": "Para pequeños emprendedores y particulares",
    "pub.landing.heroTitle": "Organiza tus finanzas personales y profesionales.",
    "pub.landing.heroSubtitle": "Lura ayuda a pequeños emprendedores y particulares a organizar ingresos, gastos, contratos y pagos sin perderse entre hojas de cálculo.",
    "pub.landing.heroCta": "Crear mi cuenta gratis",
    "pub.landing.heroNote": "Plan gratuito con límites visibles. Facturación real desactivada hasta disponer de claves y autorización.",
    "pub.landing.miniTag": "Panel · junio",
    "pub.landing.miniScope": "Profesional",
    "pub.landing.miniIncome": "Entradas",
    "pub.landing.miniExpense": "Salidas",
    "pub.landing.miniResult": "Resultado",
    "pub.landing.miniByService": "Ingresos por servicio",
    "pub.landing.svc1": "Mechas",
    "pub.landing.svc2": "Corte",
    "pub.landing.svc3": "Coloración",
    "pub.landing.svc4": "Hidratación",
    "pub.landing.featTitle": "Lo justo para tener el control",
    "pub.landing.featSubtitle": "Registrar un movimiento en menos de 30 segundos. Encontrar un contrato y su próximo pago en menos de 20. Ese es el pacto.",
    "pub.landing.f1t": "Entradas y salidas claras",
    "pub.landing.f1d": "Fecha, importe, moneda, cuenta, categoría, servicio y ámbito. Con justificante si lo tienes a mano.",
    "pub.landing.f2t": "Personal vs. Profesional",
    "pub.landing.f2d": "Separación visual inequívoca. Sabes en todo momento qué dinero es de tu vida y qué es de tu actividad.",
    "pub.landing.f3t": "Contratos y facturas",
    "pub.landing.f3d": "Coberturas, vencimientos, frecuencia y próximo pago. Con recordatorios configurables.",
    "pub.landing.f4t": "Gráficos que se entienden",
    "pub.landing.f4d": "Gasto por categoría, ingreso por servicio, fijos vs. variables y tu resultado real.",
    "pub.landing.f5t": "Multi-idioma y moneda",
    "pub.landing.f5d": "Español, inglés, francés, portugués e italiano. CHF, EUR, USD, GBP, BRL y más.",
    "pub.landing.f6t": "Listo para tu gestor",
    "pub.landing.f6d": "Exporta CSV, Excel y PDF con todas las columnas que un contable necesita revisar.",
    "pub.landing.privTitle": "Tus datos, tuyos",
    "pub.landing.priv1": "Cifrado en tránsito y en reposo.",
    "pub.landing.priv2": "Exportación y borrado de tus datos cuando quieras.",
    "pub.landing.priv3": "Nunca usamos tus datos financieros para entrenar nada.",
    "pub.landing.priv4": "La estimación de IVA es orientativa: confírmala con tu asesor.",
    "pub.landing.footContact": "Lucirene Rocha | contacto pendiente de confirmar",
    "pub.landing.footDemo": "Datos de la demo claramente identificados como demo.",
    "pub.login.title": "Iniciar sesión",
    "pub.login.subtitle": "Accede a tu espacio para organizar tus finanzas con claridad.",
    "pub.login.footerPre": "¿Aún no tienes cuenta? ",
    "pub.login.footerLink": "Créala gratis",
    "pub.login.email": "Correo",
    "pub.login.emailPh": "tu@correo.com",
    "pub.login.password": "Contraseña",
    "pub.login.submit": "Entrar",
    "pub.login.submitting": "Entrando…",
    "pub.login.or": "o",
    "pub.login.google": "Continuar con Google",
    "pub.login.forgot": "¿Olvidaste la contraseña?",
    "pub.login.privacy": "Privacidad",
    "pub.login.welcome": "Dentro. Bienvenida de nuevo.",
    "pub.login.errFallback": "No se pudo iniciar sesión. Revisa tus datos.",
    "pub.reg.title": "Crear cuenta",
    "pub.reg.subtitle": "Elige país, idioma y moneda. Podrás cambiarlo luego sin perder datos.",
    "pub.reg.footerPre": "¿Ya tienes cuenta? ",
    "pub.reg.footerLink": "Inicia sesión",
    "pub.reg.name": "Nombre",
    "pub.reg.namePh": "Tu nombre",
    "pub.reg.email": "Correo",
    "pub.reg.emailPh": "tu@correo.com",
    "pub.reg.password": "Contraseña (mín. 8)",
    "pub.reg.country": "País",
    "pub.reg.locale": "Idioma",
    "pub.reg.currency": "Moneda",
    "pub.reg.consentPre": "Acepto el tratamiento de mis datos según la ",
    "pub.reg.consentLink": "política de privacidad",
    "pub.reg.consentPost": ". Tus datos son tuyos: puedes exportarlos o eliminarlos cuando quieras. Lura no usa conexión bancaria real ni emplea tus datos financieros para entrenar modelos.",
    "pub.reg.submit": "Crear cuenta",
    "pub.reg.submitting": "Creando…",
    "pub.reg.success": "Si los datos son correctos, tu cuenta está lista. Inicia sesión para continuar.",
    "pub.reg.errFallback": "No se pudo crear la cuenta. Inténtalo de nuevo.",
    "pub.country.ES": "España",
    "pub.country.FR": "Francia",
    "pub.country.CH": "Suiza",
    "pub.country.PT": "Portugal",
    "pub.country.IT": "Italia",
    "pub.country.GB": "Reino Unido",
    "pub.forgot.title": "Recuperar acceso",
    "pub.forgot.subtitle": "Te enviaremos un enlace para restablecer la contraseña.",
    "pub.forgot.footerLink": "Volver a iniciar sesión",
    "pub.forgot.email": "Correo",
    "pub.forgot.submit": "Enviar enlace",
    "pub.forgot.submitting": "Enviando…",
    "pub.reset.title": "Nueva contraseña",
    "pub.reset.subtitle": "Elige una contraseña de al menos 8 caracteres.",
    "pub.reset.footerLink": "Volver a iniciar sesión",
    "pub.reset.password": "Nueva contraseña",
    "pub.reset.submit": "Actualizar contraseña",
    "pub.reset.submitting": "Guardando…",
    "pub.reset.success": "Contraseña actualizada. Ya puedes entrar.",
    "pub.reset.invalidTitle": "Enlace no válido",
    "pub.reset.invalidSubtitle": "Falta el token de recuperación.",
    "pub.reset.invalidBody": "Solicita de nuevo el enlace desde la pantalla de recuperación.",
    "pub.reset.invalidFooter": "Pedir uno nuevo",
  },
  en: {
    "pub.landing.navPrivacy": "Privacy",
    "pub.landing.navLogin": "Sign in",
    "pub.landing.navStart": "Start free",
    "pub.landing.heroBadge": "For small business owners and individuals",
    "pub.landing.heroTitle": "Organize your personal and professional finances.",
    "pub.landing.heroSubtitle": "Lura helps small business owners and individuals organize income, expenses, contracts and payments without getting lost in spreadsheets.",
    "pub.landing.heroCta": "Create my free account",
    "pub.landing.heroNote": "Free plan with visible limits. Real billing disabled until keys and authorization are available.",
    "pub.landing.miniTag": "Dashboard · June",
    "pub.landing.miniScope": "Professional",
    "pub.landing.miniIncome": "Income",
    "pub.landing.miniExpense": "Expenses",
    "pub.landing.miniResult": "Result",
    "pub.landing.miniByService": "Income by service",
    "pub.landing.svc1": "Highlights",
    "pub.landing.svc2": "Haircut",
    "pub.landing.svc3": "Coloring",
    "pub.landing.svc4": "Hydration",
    "pub.landing.featTitle": "Just enough to stay in control",
    "pub.landing.featSubtitle": "Log a movement in under 30 seconds. Find a contract and its next payment in under 20. That's the deal.",
    "pub.landing.f1t": "Clear income and expenses",
    "pub.landing.f1d": "Date, amount, currency, account, category, service and scope. With a receipt if you have one handy.",
    "pub.landing.f2t": "Personal vs. Professional",
    "pub.landing.f2d": "Unmistakable visual separation. You always know which money is your life's and which is your business's.",
    "pub.landing.f3t": "Contracts and invoices",
    "pub.landing.f3d": "Coverage, due dates, frequency and next payment. With configurable reminders.",
    "pub.landing.f4t": "Charts you actually understand",
    "pub.landing.f4d": "Expense by category, income by service, fixed vs. variable and your real result.",
    "pub.landing.f5t": "Multi-language and currency",
    "pub.landing.f5d": "Spanish, English, French, Portuguese and Italian. CHF, EUR, USD, GBP, BRL and more.",
    "pub.landing.f6t": "Ready for your accountant",
    "pub.landing.f6d": "Export CSV, Excel and PDF with every column an accountant needs to review.",
    "pub.landing.privTitle": "Your data, yours",
    "pub.landing.priv1": "Encrypted in transit and at rest.",
    "pub.landing.priv2": "Export and delete your data whenever you want.",
    "pub.landing.priv3": "We never use your financial data to train anything.",
    "pub.landing.priv4": "The VAT estimate is indicative: confirm it with your advisor.",
    "pub.landing.footContact": "Lucirene Rocha | contact to be confirmed",
    "pub.landing.footDemo": "Demo data clearly identified as demo.",
    "pub.login.title": "Sign in",
    "pub.login.subtitle": "Access your workspace to organize your finances clearly.",
    "pub.login.footerPre": "Don't have an account yet? ",
    "pub.login.footerLink": "Create one free",
    "pub.login.email": "Email",
    "pub.login.emailPh": "you@email.com",
    "pub.login.password": "Password",
    "pub.login.submit": "Sign in",
    "pub.login.submitting": "Signing in…",
    "pub.login.or": "or",
    "pub.login.google": "Continue with Google",
    "pub.login.forgot": "Forgot your password?",
    "pub.login.privacy": "Privacy",
    "pub.login.welcome": "You're in. Welcome back.",
    "pub.login.errFallback": "Couldn't sign in. Check your details.",
    "pub.reg.title": "Create account",
    "pub.reg.subtitle": "Choose country, language and currency. You can change it later without losing data.",
    "pub.reg.footerPre": "Already have an account? ",
    "pub.reg.footerLink": "Sign in",
    "pub.reg.name": "Name",
    "pub.reg.namePh": "Your name",
    "pub.reg.email": "Email",
    "pub.reg.emailPh": "you@email.com",
    "pub.reg.password": "Password (min. 8)",
    "pub.reg.country": "Country",
    "pub.reg.locale": "Language",
    "pub.reg.currency": "Currency",
    "pub.reg.consentPre": "I accept the processing of my data according to the ",
    "pub.reg.consentLink": "privacy policy",
    "pub.reg.consentPost": ". Your data is yours: you can export or delete it whenever you want. Lura does not use a real bank connection or use your financial data to train models.",
    "pub.reg.submit": "Create account",
    "pub.reg.submitting": "Creating…",
    "pub.reg.success": "If your details are correct, your account is ready. Sign in to continue.",
    "pub.reg.errFallback": "Couldn't create the account. Please try again.",
    "pub.country.ES": "Spain",
    "pub.country.FR": "France",
    "pub.country.CH": "Switzerland",
    "pub.country.PT": "Portugal",
    "pub.country.IT": "Italy",
    "pub.country.GB": "United Kingdom",
    "pub.forgot.title": "Recover access",
    "pub.forgot.subtitle": "We'll send you a link to reset your password.",
    "pub.forgot.footerLink": "Back to sign in",
    "pub.forgot.email": "Email",
    "pub.forgot.submit": "Send link",
    "pub.forgot.submitting": "Sending…",
    "pub.reset.title": "New password",
    "pub.reset.subtitle": "Choose a password of at least 8 characters.",
    "pub.reset.footerLink": "Back to sign in",
    "pub.reset.password": "New password",
    "pub.reset.submit": "Update password",
    "pub.reset.submitting": "Saving…",
    "pub.reset.success": "Password updated. You can sign in now.",
    "pub.reset.invalidTitle": "Invalid link",
    "pub.reset.invalidSubtitle": "The recovery token is missing.",
    "pub.reset.invalidBody": "Request the link again from the recovery screen.",
    "pub.reset.invalidFooter": "Request a new one",
  },
  fr: {
    "pub.landing.navPrivacy": "Confidentialité",
    "pub.landing.navLogin": "Connexion",
    "pub.landing.navStart": "Commencer gratuitement",
    "pub.landing.heroBadge": "Pour les petits entrepreneurs et les particuliers",
    "pub.landing.heroTitle": "Organisez vos finances personnelles et professionnelles.",
    "pub.landing.heroSubtitle": "Lura aide les petits entrepreneurs et les particuliers à organiser revenus, dépenses, contrats et paiements sans se perdre dans les tableurs.",
    "pub.landing.heroCta": "Créer mon compte gratuit",
    "pub.landing.heroNote": "Offre gratuite avec limites visibles. Facturation réelle désactivée jusqu'à l'obtention des clés et de l'autorisation.",
    "pub.landing.miniTag": "Tableau de bord · juin",
    "pub.landing.miniScope": "Professionnel",
    "pub.landing.miniIncome": "Entrées",
    "pub.landing.miniExpense": "Sorties",
    "pub.landing.miniResult": "Résultat",
    "pub.landing.miniByService": "Revenus par service",
    "pub.landing.svc1": "Mèches",
    "pub.landing.svc2": "Coupe",
    "pub.landing.svc3": "Coloration",
    "pub.landing.svc4": "Hydratation",
    "pub.landing.featTitle": "Juste ce qu'il faut pour garder le contrôle",
    "pub.landing.featSubtitle": "Enregistrer un mouvement en moins de 30 secondes. Trouver un contrat et son prochain paiement en moins de 20. Voilà le pacte.",
    "pub.landing.f1t": "Entrées et sorties claires",
    "pub.landing.f1d": "Date, montant, devise, compte, catégorie, service et périmètre. Avec justificatif si vous l'avez sous la main.",
    "pub.landing.f2t": "Personnel vs. Professionnel",
    "pub.landing.f2d": "Séparation visuelle sans équivoque. Vous savez à tout moment quel argent relève de votre vie et lequel de votre activité.",
    "pub.landing.f3t": "Contrats et factures",
    "pub.landing.f3d": "Couvertures, échéances, fréquence et prochain paiement. Avec des rappels configurables.",
    "pub.landing.f4t": "Des graphiques compréhensibles",
    "pub.landing.f4d": "Dépense par catégorie, revenu par service, fixes vs. variables et votre résultat réel.",
    "pub.landing.f5t": "Multilingue et multidevise",
    "pub.landing.f5d": "Espagnol, anglais, français, portugais et italien. CHF, EUR, USD, GBP, BRL et plus.",
    "pub.landing.f6t": "Prêt pour votre comptable",
    "pub.landing.f6d": "Exportez CSV, Excel et PDF avec toutes les colonnes qu'un comptable doit vérifier.",
    "pub.landing.privTitle": "Vos données, à vous",
    "pub.landing.priv1": "Chiffrées en transit et au repos.",
    "pub.landing.priv2": "Exportation et suppression de vos données quand vous voulez.",
    "pub.landing.priv3": "Nous n'utilisons jamais vos données financières pour entraîner quoi que ce soit.",
    "pub.landing.priv4": "L'estimation de TVA est indicative : confirmez-la avec votre conseiller.",
    "pub.landing.footContact": "Lucirene Rocha | contact à confirmer",
    "pub.landing.footDemo": "Données de démo clairement identifiées comme démo.",
    "pub.login.title": "Connexion",
    "pub.login.subtitle": "Accédez à votre espace pour organiser vos finances en toute clarté.",
    "pub.login.footerPre": "Pas encore de compte ? ",
    "pub.login.footerLink": "Créez-le gratuitement",
    "pub.login.email": "E-mail",
    "pub.login.emailPh": "vous@email.com",
    "pub.login.password": "Mot de passe",
    "pub.login.submit": "Se connecter",
    "pub.login.submitting": "Connexion…",
    "pub.login.or": "ou",
    "pub.login.google": "Continuer avec Google",
    "pub.login.forgot": "Mot de passe oublié ?",
    "pub.login.privacy": "Confidentialité",
    "pub.login.welcome": "C'est bon. Ravi de vous revoir.",
    "pub.login.errFallback": "Connexion impossible. Vérifiez vos informations.",
    "pub.reg.title": "Créer un compte",
    "pub.reg.subtitle": "Choisissez pays, langue et devise. Vous pourrez les modifier plus tard sans perdre de données.",
    "pub.reg.footerPre": "Vous avez déjà un compte ? ",
    "pub.reg.footerLink": "Connectez-vous",
    "pub.reg.name": "Nom",
    "pub.reg.namePh": "Votre nom",
    "pub.reg.email": "E-mail",
    "pub.reg.emailPh": "vous@email.com",
    "pub.reg.password": "Mot de passe (min. 8)",
    "pub.reg.country": "Pays",
    "pub.reg.locale": "Langue",
    "pub.reg.currency": "Devise",
    "pub.reg.consentPre": "J'accepte le traitement de mes données conformément à la ",
    "pub.reg.consentLink": "politique de confidentialité",
    "pub.reg.consentPost": ". Vos données vous appartiennent : vous pouvez les exporter ou les supprimer quand vous voulez. Lura n'utilise pas de connexion bancaire réelle ni vos données financières pour entraîner des modèles.",
    "pub.reg.submit": "Créer un compte",
    "pub.reg.submitting": "Création…",
    "pub.reg.success": "Si vos informations sont correctes, votre compte est prêt. Connectez-vous pour continuer.",
    "pub.reg.errFallback": "Impossible de créer le compte. Réessayez.",
    "pub.country.ES": "Espagne",
    "pub.country.FR": "France",
    "pub.country.CH": "Suisse",
    "pub.country.PT": "Portugal",
    "pub.country.IT": "Italie",
    "pub.country.GB": "Royaume-Uni",
    "pub.forgot.title": "Récupérer l'accès",
    "pub.forgot.subtitle": "Nous vous enverrons un lien pour réinitialiser le mot de passe.",
    "pub.forgot.footerLink": "Retour à la connexion",
    "pub.forgot.email": "E-mail",
    "pub.forgot.submit": "Envoyer le lien",
    "pub.forgot.submitting": "Envoi…",
    "pub.reset.title": "Nouveau mot de passe",
    "pub.reset.subtitle": "Choisissez un mot de passe d'au moins 8 caractères.",
    "pub.reset.footerLink": "Retour à la connexion",
    "pub.reset.password": "Nouveau mot de passe",
    "pub.reset.submit": "Mettre à jour le mot de passe",
    "pub.reset.submitting": "Enregistrement…",
    "pub.reset.success": "Mot de passe mis à jour. Vous pouvez vous connecter.",
    "pub.reset.invalidTitle": "Lien non valide",
    "pub.reset.invalidSubtitle": "Le jeton de récupération est manquant.",
    "pub.reset.invalidBody": "Demandez à nouveau le lien depuis l'écran de récupération.",
    "pub.reset.invalidFooter": "En demander un nouveau",
  },
  pt: {
    "pub.landing.navPrivacy": "Privacidade",
    "pub.landing.navLogin": "Entrar",
    "pub.landing.navStart": "Começar grátis",
    "pub.landing.heroBadge": "Para pequenos empreendedores e particulares",
    "pub.landing.heroTitle": "Organize as suas finanças pessoais e profissionais.",
    "pub.landing.heroSubtitle": "O Lura ajuda pequenos empreendedores e particulares a organizar receitas, despesas, contratos e pagamentos sem se perderem em folhas de cálculo.",
    "pub.landing.heroCta": "Criar a minha conta grátis",
    "pub.landing.heroNote": "Plano gratuito com limites visíveis. Faturação real desativada até dispor de chaves e autorização.",
    "pub.landing.miniTag": "Painel · junho",
    "pub.landing.miniScope": "Profissional",
    "pub.landing.miniIncome": "Entradas",
    "pub.landing.miniExpense": "Saídas",
    "pub.landing.miniResult": "Resultado",
    "pub.landing.miniByService": "Receitas por serviço",
    "pub.landing.svc1": "Madeixas",
    "pub.landing.svc2": "Corte",
    "pub.landing.svc3": "Coloração",
    "pub.landing.svc4": "Hidratação",
    "pub.landing.featTitle": "O suficiente para ter o controlo",
    "pub.landing.featSubtitle": "Registar um movimento em menos de 30 segundos. Encontrar um contrato e o seu próximo pagamento em menos de 20. É este o pacto.",
    "pub.landing.f1t": "Entradas e saídas claras",
    "pub.landing.f1d": "Data, valor, moeda, conta, categoria, serviço e âmbito. Com comprovativo se o tiver à mão.",
    "pub.landing.f2t": "Pessoal vs. Profissional",
    "pub.landing.f2d": "Separação visual inequívoca. Sabe sempre que dinheiro é da sua vida e qual é da sua atividade.",
    "pub.landing.f3t": "Contratos e faturas",
    "pub.landing.f3d": "Coberturas, vencimentos, frequência e próximo pagamento. Com lembretes configuráveis.",
    "pub.landing.f4t": "Gráficos que se entendem",
    "pub.landing.f4d": "Gasto por categoria, receita por serviço, fixos vs. variáveis e o seu resultado real.",
    "pub.landing.f5t": "Multi-idioma e moeda",
    "pub.landing.f5d": "Espanhol, inglês, francês, português e italiano. CHF, EUR, USD, GBP, BRL e mais.",
    "pub.landing.f6t": "Pronto para o seu contabilista",
    "pub.landing.f6d": "Exporte CSV, Excel e PDF com todas as colunas que um contabilista precisa de rever.",
    "pub.landing.privTitle": "Os seus dados, seus",
    "pub.landing.priv1": "Cifrados em trânsito e em repouso.",
    "pub.landing.priv2": "Exportação e eliminação dos seus dados quando quiser.",
    "pub.landing.priv3": "Nunca usamos os seus dados financeiros para treinar nada.",
    "pub.landing.priv4": "A estimativa de IVA é indicativa: confirme-a com o seu consultor.",
    "pub.landing.footContact": "Lucirene Rocha | contacto por confirmar",
    "pub.landing.footDemo": "Dados da demo claramente identificados como demo.",
    "pub.login.title": "Entrar",
    "pub.login.subtitle": "Aceda ao seu espaço para organizar as suas finanças com clareza.",
    "pub.login.footerPre": "Ainda não tem conta? ",
    "pub.login.footerLink": "Crie-a grátis",
    "pub.login.email": "E-mail",
    "pub.login.emailPh": "voce@email.com",
    "pub.login.password": "Palavra-passe",
    "pub.login.submit": "Entrar",
    "pub.login.submitting": "A entrar…",
    "pub.login.or": "ou",
    "pub.login.google": "Continuar com Google",
    "pub.login.forgot": "Esqueceu-se da palavra-passe?",
    "pub.login.privacy": "Privacidade",
    "pub.login.welcome": "Lá dentro. Bem-vinda de volta.",
    "pub.login.errFallback": "Não foi possível entrar. Verifique os seus dados.",
    "pub.reg.title": "Criar conta",
    "pub.reg.subtitle": "Escolha país, idioma e moeda. Pode alterá-los depois sem perder dados.",
    "pub.reg.footerPre": "Já tem conta? ",
    "pub.reg.footerLink": "Inicie sessão",
    "pub.reg.name": "Nome",
    "pub.reg.namePh": "O seu nome",
    "pub.reg.email": "E-mail",
    "pub.reg.emailPh": "voce@email.com",
    "pub.reg.password": "Palavra-passe (mín. 8)",
    "pub.reg.country": "País",
    "pub.reg.locale": "Idioma",
    "pub.reg.currency": "Moeda",
    "pub.reg.consentPre": "Aceito o tratamento dos meus dados de acordo com a ",
    "pub.reg.consentLink": "política de privacidade",
    "pub.reg.consentPost": ". Os seus dados são seus: pode exportá-los ou eliminá-los quando quiser. O Lura não usa ligação bancária real nem os seus dados financeiros para treinar modelos.",
    "pub.reg.submit": "Criar conta",
    "pub.reg.submitting": "A criar…",
    "pub.reg.success": "Se os dados estiverem corretos, a sua conta está pronta. Inicie sessão para continuar.",
    "pub.reg.errFallback": "Não foi possível criar a conta. Tente novamente.",
    "pub.country.ES": "Espanha",
    "pub.country.FR": "França",
    "pub.country.CH": "Suíça",
    "pub.country.PT": "Portugal",
    "pub.country.IT": "Itália",
    "pub.country.GB": "Reino Unido",
    "pub.forgot.title": "Recuperar acesso",
    "pub.forgot.subtitle": "Enviaremos um link para repor a palavra-passe.",
    "pub.forgot.footerLink": "Voltar a entrar",
    "pub.forgot.email": "E-mail",
    "pub.forgot.submit": "Enviar link",
    "pub.forgot.submitting": "A enviar…",
    "pub.reset.title": "Nova palavra-passe",
    "pub.reset.subtitle": "Escolha uma palavra-passe de pelo menos 8 caracteres.",
    "pub.reset.footerLink": "Voltar a entrar",
    "pub.reset.password": "Nova palavra-passe",
    "pub.reset.submit": "Atualizar palavra-passe",
    "pub.reset.submitting": "A guardar…",
    "pub.reset.success": "Palavra-passe atualizada. Já pode entrar.",
    "pub.reset.invalidTitle": "Link inválido",
    "pub.reset.invalidSubtitle": "Falta o token de recuperação.",
    "pub.reset.invalidBody": "Peça novamente o link no ecrã de recuperação.",
    "pub.reset.invalidFooter": "Pedir um novo",
  },
  it: {
    "pub.landing.navPrivacy": "Privacy",
    "pub.landing.navLogin": "Accedi",
    "pub.landing.navStart": "Inizia gratis",
    "pub.landing.heroBadge": "Per piccoli imprenditori e privati",
    "pub.landing.heroTitle": "Organizza le tue finanze personali e professionali.",
    "pub.landing.heroSubtitle": "Lura aiuta piccoli imprenditori e privati a organizzare entrate, uscite, contratti e pagamenti senza perdersi tra i fogli di calcolo.",
    "pub.landing.heroCta": "Crea il mio account gratuito",
    "pub.landing.heroNote": "Piano gratuito con limiti visibili. Fatturazione reale disattivata fino alla disponibilità di chiavi e autorizzazione.",
    "pub.landing.miniTag": "Pannello · giugno",
    "pub.landing.miniScope": "Professionale",
    "pub.landing.miniIncome": "Entrate",
    "pub.landing.miniExpense": "Uscite",
    "pub.landing.miniResult": "Risultato",
    "pub.landing.miniByService": "Entrate per servizio",
    "pub.landing.svc1": "Colpi di sole",
    "pub.landing.svc2": "Taglio",
    "pub.landing.svc3": "Colorazione",
    "pub.landing.svc4": "Idratazione",
    "pub.landing.featTitle": "Quel che basta per avere il controllo",
    "pub.landing.featSubtitle": "Registrare un movimento in meno di 30 secondi. Trovare un contratto e il suo prossimo pagamento in meno di 20. Questo è il patto.",
    "pub.landing.f1t": "Entrate e uscite chiare",
    "pub.landing.f1d": "Data, importo, valuta, conto, categoria, servizio e ambito. Con giustificativo se ce l'hai a portata di mano.",
    "pub.landing.f2t": "Personale vs. Professionale",
    "pub.landing.f2d": "Separazione visiva inequivocabile. Sai sempre quale denaro è della tua vita e quale della tua attività.",
    "pub.landing.f3t": "Contratti e fatture",
    "pub.landing.f3d": "Coperture, scadenze, frequenza e prossimo pagamento. Con promemoria configurabili.",
    "pub.landing.f4t": "Grafici che si capiscono",
    "pub.landing.f4d": "Spesa per categoria, entrata per servizio, fissi vs. variabili e il tuo risultato reale.",
    "pub.landing.f5t": "Multilingua e multivaluta",
    "pub.landing.f5d": "Spagnolo, inglese, francese, portoghese e italiano. CHF, EUR, USD, GBP, BRL e altro.",
    "pub.landing.f6t": "Pronto per il tuo commercialista",
    "pub.landing.f6d": "Esporta CSV, Excel e PDF con tutte le colonne che un commercialista deve rivedere.",
    "pub.landing.privTitle": "I tuoi dati, tuoi",
    "pub.landing.priv1": "Cifrati in transito e a riposo.",
    "pub.landing.priv2": "Esportazione ed eliminazione dei tuoi dati quando vuoi.",
    "pub.landing.priv3": "Non usiamo mai i tuoi dati finanziari per addestrare nulla.",
    "pub.landing.priv4": "La stima dell'IVA è indicativa: confermala con il tuo consulente.",
    "pub.landing.footContact": "Lucirene Rocha | contatto da confermare",
    "pub.landing.footDemo": "Dati demo chiaramente identificati come demo.",
    "pub.login.title": "Accedi",
    "pub.login.subtitle": "Accedi al tuo spazio per organizzare le tue finanze con chiarezza.",
    "pub.login.footerPre": "Non hai ancora un account? ",
    "pub.login.footerLink": "Crealo gratis",
    "pub.login.email": "E-mail",
    "pub.login.emailPh": "tu@email.com",
    "pub.login.password": "Password",
    "pub.login.submit": "Accedi",
    "pub.login.submitting": "Accesso…",
    "pub.login.or": "o",
    "pub.login.google": "Continua con Google",
    "pub.login.forgot": "Password dimenticata?",
    "pub.login.privacy": "Privacy",
    "pub.login.welcome": "Dentro. Bentornata.",
    "pub.login.errFallback": "Accesso non riuscito. Controlla i tuoi dati.",
    "pub.reg.title": "Crea account",
    "pub.reg.subtitle": "Scegli paese, lingua e valuta. Potrai modificarli in seguito senza perdere dati.",
    "pub.reg.footerPre": "Hai già un account? ",
    "pub.reg.footerLink": "Accedi",
    "pub.reg.name": "Nome",
    "pub.reg.namePh": "Il tuo nome",
    "pub.reg.email": "E-mail",
    "pub.reg.emailPh": "tu@email.com",
    "pub.reg.password": "Password (min. 8)",
    "pub.reg.country": "Paese",
    "pub.reg.locale": "Lingua",
    "pub.reg.currency": "Valuta",
    "pub.reg.consentPre": "Accetto il trattamento dei miei dati secondo la ",
    "pub.reg.consentLink": "informativa sulla privacy",
    "pub.reg.consentPost": ". I tuoi dati sono tuoi: puoi esportarli o eliminarli quando vuoi. Lura non usa una connessione bancaria reale né i tuoi dati finanziari per addestrare modelli.",
    "pub.reg.submit": "Crea account",
    "pub.reg.submitting": "Creazione…",
    "pub.reg.success": "Se i dati sono corretti, il tuo account è pronto. Accedi per continuare.",
    "pub.reg.errFallback": "Impossibile creare l'account. Riprova.",
    "pub.country.ES": "Spagna",
    "pub.country.FR": "Francia",
    "pub.country.CH": "Svizzera",
    "pub.country.PT": "Portogallo",
    "pub.country.IT": "Italia",
    "pub.country.GB": "Regno Unito",
    "pub.forgot.title": "Recupera l'accesso",
    "pub.forgot.subtitle": "Ti invieremo un link per reimpostare la password.",
    "pub.forgot.footerLink": "Torna all'accesso",
    "pub.forgot.email": "E-mail",
    "pub.forgot.submit": "Invia link",
    "pub.forgot.submitting": "Invio…",
    "pub.reset.title": "Nuova password",
    "pub.reset.subtitle": "Scegli una password di almeno 8 caratteri.",
    "pub.reset.footerLink": "Torna all'accesso",
    "pub.reset.password": "Nuova password",
    "pub.reset.submit": "Aggiorna password",
    "pub.reset.submitting": "Salvataggio…",
    "pub.reset.success": "Password aggiornata. Ora puoi accedere.",
    "pub.reset.invalidTitle": "Link non valido",
    "pub.reset.invalidSubtitle": "Manca il token di recupero.",
    "pub.reset.invalidBody": "Richiedi di nuovo il link dalla schermata di recupero.",
    "pub.reset.invalidFooter": "Richiedine uno nuovo",
  },
};

export const LANG_NAMES = { es: "Español", en: "English", fr: "Français", pt: "Português", it: "Italiano" };
